export const ACTUALIZAR_LIST_HERRAMIENTA = "ACTUALIZAR_LIST_HERRAMIENTA";
export const MODIFICAR_HERRAMIENTA = "MODIFICAR_HERRAMIENTA";
export const AGREGAR_HERRAMIENTA = "AGREGAR_HERRAMIENTA";
export const ELIMINAR_HERRAMIENTA = "ELIMINAR_HERRAMIENTA";
